import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-71ea7c58"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "musicList"
};
const _hoisted_2 = {
  class: "musicTop"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "推荐歌单", -1));

const _hoisted_4 = {
  class: "more"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("更多");

const _hoisted_6 = {
  class: "musicContent"
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_router_link = _resolveComponent("router-link");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_van_icon, {
    name: "arrow"
  })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_swipe, {
    class: "my-swpie",
    loop: false,
    width: 140,
    "show-indicators": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.musiclist, item => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: item
      }, {
        default: _withCtx(() => [_createVNode(_component_router_link, {
          to: {
            path: '/musiclistitem',
            query: {
              id: item.id
            }
          }
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: item.picUrl,
            alt: ""
          }, null, 8, _hoisted_7), _createElementVNode("span", null, [_createVNode(_component_van_icon, {
            name: "play"
          }), _createTextVNode(" " + _toDisplayString($setup.changeCount(item.playCount)), 1)]), _createElementVNode("p", null, _toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]);
}